(function() {
  var erxProductId = '7442290';
  var $body = $('body');
  var $erxErrorModal = $('#modal-erx-error');
  var $apnErx = $('.apn-erx');
  var scanner = null;

  function isMobileDevice() {
    return ($body.hasClass('isMobile') || $body.hasClass('isTablet'));
  }

  var hasVideoInput = async function() {
    var hasVideoInput = false;
    if (navigator.mediaDevices && navigator.mediaDevices.enumerateDevices) {
      var devices = await navigator.mediaDevices.enumerateDevices();
      devices.forEach(function(device) {
        if (device.kind === 'videoinput') {
          hasVideoInput = true;
        }
      });
    }
    return hasVideoInput;
  }

  function setScannerHeight($apnErxScanner) {
    if (isMobileDevice()) {
      var scannerOffset = $apnErxScanner.offset();
      $apnErxScanner.css('height', (window.innerHeight - scannerOffset.top) + 'px');
    }
  }

  function initScanner($apnErxScanner) {
    var $apnAdvice = $('.apn-erx__advice', $apnErx).first();
    var $apnScannerArea = $('.apn-erx__scanner-area', $apnErx).first();
    var $apnStartScannerWrapper = $('.apn-erx__start-scan-wrapper', $apnErx).first();
    var $apnErxScannerOverlay = $('.apn-erx__scanner__overlay', $apnErx);
    var overlayTimer = null;
    var $apnErxLoadingIndicator = $('.js-apn-erx__loading-indicator', $apnErx);

    function registerModalHandler() {
      $.merge($('#modal-productAdded'), $erxErrorModal)
        .off('hide.bs.modal')
        .on('hide.bs.modal', function() {
          resumeScanner();
        })
        .off('show.bs.modal')
        .on('show.bs.modal', function() {
          pauseScanner();
        });
    }

    function initTorchToggle() {
      var $torchToggle = $('#apn-erx__torch');
      var $torchUiButton = $('apn-erx__ui-button', $torchToggle);
      var $torchUiButtonLabel = $('apn-erx__ui-button-label', $torchToggle);
      $torchToggle.off('click.Erx').on('click.Erx', function(e) {
        if ($torchToggle.data('torchActive')) {
          scanner.turnOffTorch();
          $torchUiButton.removeClass('-torch-on');
          $torchUiButtonLabel.html('Licht einschalten');
          $torchToggle.data('torchActive', false);
        } else {
          scanner.turnOnTorch();
          $torchUiButton.addClass('-torch-on');
          $torchUiButtonLabel.html('Licht ausschalten');
          $torchToggle.data('torchActive', true);
        }
      });
      $torchToggle.removeClass('d-none');
    }

    function showPermissionError() {
      showScannerArea(false);
      $('.js-apn-erx__scanner-init', $apnErx).hide();
      $('*[data-permission-error]', $apnErx).each(function(i, e) {
        $(e).removeClass('d-none').html($(e).data('permissionError'));
      });
    }

    function showScannerArea(show) {
      $apnAdvice.toggleClass('d-none', !show);
      $apnErxScanner.toggleClass('d-none', !show);
      $apnStartScannerWrapper.toggleClass('d-none', show);
      $apnScannerArea.toggleClass('-is-scanning', show);

      if (show) {
        $apnErxLoadingIndicator.toggleClass('d-none');
        if(!isMobileDevice()){
          $apnErxScanner.addClass('bg-transparent');
        }

        setScannerHeight($apnErxScanner);
      }
    }

    function pauseScanner() {
      if (scanner !== null) {
        scanner.pause();
        scanner.pauseScan();
      }
    }

    function resumeScanner() {
      if (scanner !== null) {
        $apnErxScanner.addClass('-cover-canvas');
        scanner.resumeScan();
        scanner.play();
      }
    }

    function toggleScanAcceptButtons(show) {
      var $mobileUiButtons = $('.apn-erx__ui-buttons-bottom', $apnErxScanner);
      var $acceptScanButtons = $('.apn-erx__accept-scan-buttons', $apnErxScanner);

      if (show) {
        $mobileUiButtons.hide();
        $acceptScanButtons.css('display', 'flex');
      } else {
        $mobileUiButtons.removeAttr('style');
        $acceptScanButtons.hide();
      }
    }

    var scanResults;
    function initScanAcceptButtons() {
      $('.js-apn-erx__scan-reject', $apnErxScanner).off('click.Erx').on('click.Erx', function() {
        toggleScanAcceptButtons(false);
        scanResults = null;
        resumeScanner();
      });
      $('.js-apn-erx__scan-accept', $apnErxScanner).off('click.Erx').on('click.Erx', function() {
        toggleScanAcceptButtons(false);
        addErxToCart(scanResults);
      });
    }

    initScanAcceptButtons();
    showScannerArea(true);

    (async function() {

      var hasCamera  = await hasVideoInput();
      if (!hasCamera) {
        return;
      }

      try {
        scanner = scanner || await Dynamsoft.DBR.BarcodeScanner.createInstance();
      } catch (ex) {}

      if (scanner) {
        scanner.onFrameRead = function(results) {
          if (results.length) {
            saveToErrorLogIfLicenceErrorInResults(results);
            pauseScanner();
            scanResults = results;
            licenseLog(scanResults);
            toggleScanAcceptButtons(true);
          }
        };

        scanner.onPlayed = function(rsl) {
          $apnErxScanner.removeClass('-cover-canvas');
          $apnErxLoadingIndicator.toggleClass('d-none');
          $apnErxScannerOverlay.toggleClass('d-none');

          clearTimeout(overlayTimer);
          overlayTimer = setTimeout(function() {
            $apnErxScanner.toggleClass('-clear-cam');
          }, 1500);
        };

        scanner.bVibrateOnSuccessfulRead = 'unduplicated';
        scanner.barcodeFillStyle = 'rgba(103, 203, 74, 0.3)';
        scanner.barcodeStrokeStyle = 'rgba(63, 163, 34, 0.6)';
        scanner.barcodeLineWidth = 3;
        // scanner.regionMaskFillStyle = 'rgba(82,115,252,0.3)';
        // scanner.regionMaskStrokeStyle = 'rgba(255,10,0,0.78)';
        // scanner.regionMaskLineWidth = 1;

        await scanner.setUIElement($apnErxScanner.get(0));

        try {
          await scanner.show();
        } catch (e) {
          scanner.close();
          showPermissionError();
          return;
        }

        var runtimeSettings = await scanner.getRuntimeSettings();
        runtimeSettings = setBarcodeReaderDefaults(runtimeSettings);

        // runtimeSettings.region.regionMeasuredByPercentage = 1;
        // runtimeSettings.region.regionLeft = 5;
        // runtimeSettings.region.regionTop = 50;
        // runtimeSettings.region.regionRight = 95;
        // runtimeSettings.region.regionBottom = 95;

        await scanner.updateRuntimeSettings(runtimeSettings);

        var hasTorch = false;
        try {
          hasTorch = scanner.getCapabilities().hasOwnProperty('torch');
        } catch (e) {}
        if (hasTorch) {
          initTorchToggle();
        }

        registerModalHandler();
      }
    })();
  }

  function convertPdfToCanvas(file) {
    return new Promise(function(resolve) {
      // TODO Use dynamic import and get rid of aponeo_de in path
      $.cachedScript('/js/aponeo_de/min/libs/pdf-js/pdf.js').done(function() {
        pdfjsLib.GlobalWorkerOptions.workerSrc = '/js/aponeo_de/min/libs/pdf-js/pdf.worker.js';

        var fileReader = new FileReader();
        fileReader.onload = function(e) {
          var typedArray = new Uint8Array(e.target.result);

          const loadingTask = pdfjsLib.getDocument(typedArray);
          loadingTask.promise.then(function(pdf) {
            pdf.getPage(1).then(function(page) {
              var viewport = page.getViewport({ scale: 1 });
              var canvas = document.createElement('canvas');
              var context = canvas.getContext('2d');
              canvas.height = viewport.height;
              canvas.width = viewport.width;

              var renderContext = { canvasContext: context, viewport: viewport };
              var renderTask = page.render(renderContext);
              renderTask.promise.then(function() {
                resolve(canvas);
              });
            });
          });
        }
        fileReader.readAsArrayBuffer(file);
      });
    });
  }

  function initReader($apnErxUpload) {
    var reader = null;
    $apnErxUpload.on('change.Erx', async function(e) {
      if ($(e.target).prop('files').length > 0) {
        $body.addClass('loading');
        var file = $(e.target).prop('files').item(0);
        try {
          reader = reader || await Dynamsoft.DBR.BarcodeReader.createInstance();
        } catch (e) {
          // TODO Fehlermeldung
          // alert(e.message);
          // throw e;
        }

        if (reader) {
          var runtimeSettings = await reader.getRuntimeSettings();
          runtimeSettings = setBarcodeReaderDefaults(runtimeSettings);
          await reader.updateRuntimeSettings(runtimeSettings);

          if (file.type === 'application/pdf') {
            file = await convertPdfToCanvas(file);
          }

          var results = await reader.decode(file);
          saveToErrorLogIfLicenceErrorInResults(results);
          //var results = []; // fake error
          //console.log('#Error:35-TI')
          licenseLog(results);
          addErxToCart(results);

          $(e.target).val('');
        }
        $body.removeClass('loading');
      }
    });
    $apnErxUpload.prop('disabled', false).parent('label').removeClass('disabled');
  }

  /**
   * @param results Barcode reader or scanner results
   */
  function saveToErrorLogIfLicenceErrorInResults(results) {
    const DATAMATRIX_LICENSE_IS_INVALID_ERROR_CODE = '-10020';
    const DATAMATRIX_LICENSE_IS_INVALID_ERROR_MESSAGE = 'The license for the DATAMATRIX module is invalid ';

    results.every(function(result) {
      if (result.hasOwnProperty('exception')) {
        // if(DATAMATRIX_LICENSE_IS_INVALID_ERROR_CODE === result.exception.code) {
        if(result.exception.code) {
          console.log(result.exception);
          errorLog(result.exception.code , result.exception.message);
          return false;
        }
      }
    });
  }

  function errorLog (ecode, emessage) {
    $.get( '/rpc.php', { action: "licenselogerx", errorcode: ecode, errormsg: emessage} );
  }

  function licenseLog (scanResults) {
    console.log('Scan result...');
    // console.log(scanResults);
    let funds = scanResults.length;
    // maybe we could send some parts of the result
    $.get( '/rpc.php', { action: "licenselogerx", funds: funds} );

  }


  function addErxToCart(results) {

    function parseResults(results) {
      var erxCodes = [];
      //results = []; // fake error
      //console.log('#Error:36-TI')
      results.forEach(function(result) {
        var barcodeText;
        // e.g. {"urls":["Task/160.424.986.201.644.64/$accept?ac=14e5ed98461cbe0e2aa647c45b03fbbb11340dd55e8324563319a89ff93a5f30"]}
        var regEx = new RegExp('{\s*"urls"\s*:\s*\\[(\s*"Task\/(\\d{3}\.){5}\\d{2}\/\\$accept\\?ac=[0-9a-f]{64}"\s*,?)+\]\s*}');
        if (result.hasOwnProperty('barcodeText') && regEx.test(result.barcodeText)) {
          barcodeText = JSON.parse(result.barcodeText);
          erxCodes = erxCodes.concat(barcodeText.urls);
        }
      });

      // make values unique
      // @see https://stackoverflow.com/questions/1584370/how-to-merge-two-arrays-in-javascript-and-de-duplicate-items
      for (var i = 0; i < erxCodes.length; ++i) {
        for (var j = i + 1; j < erxCodes.length; ++j) {
          if (erxCodes[i] === erxCodes[j]) {
            erxCodes.splice(j--, 1);
          }
        }
      }

      return erxCodes;
    };

    var erxCodes = parseResults(results);
    if (erxCodes.length > 0) {
      apnCart.add(erxProductId, 1, {urls:erxCodes});

      /* WEB-4374 GA push Event tracking */
      if (window['google_tag_manager']) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'erezept_scan'
        });
      }
      /* eof WEB-4374 GA push Event */
    } else {
      $erxErrorModal.modal('show');
    }
  };

  function setBarcodeReaderDefaults(runTimeSettings) {
    runTimeSettings.barcodeFormatIds = Dynamsoft.DBR.EnumBarcodeFormat.BF_DATAMATRIX;
    return runTimeSettings;
  }

  $(document).ready(function() {
    if ($apnErx.length > 0) {
      // regular (online) license
      //Dynamsoft.DBR.BarcodeReader.organizationID = 100591001;
      // new offline license
      //Dynamsoft.DBR.BarcodeReader.productKeys = 'f0068NQAAAJYpuyujXT40Pb5FPPbVC9FvWSqhjdpx/0BEPk8mGCvZG/r+QE+7nsdl3PH2GkFNNQfdTv/eOrIPrSVGU98EmGA=';
      //Dynamsoft.DBR.BarcodeReader.productKeys = 'f0068MgAAALNnZWNpqPP01+os0pB7fKdkaTV43UsXQraBZLstuv1W7hC/XbVjL4ol9KMSj4Dss2hCaSoCrmfbEtDON5WQfag=';
      //Dynamsoft.DBR.BarcodeReader.productKeys = 'f0068MgAAAOosbrJUjtM0Ch+Zmf5pG51DjGDaApguh5GMJ0XC9011sP/fn8RfNiVwbbzr4HIfSp+2M/J/K9iN4G1qhet4cZM=';
      //Dynamsoft.DBR.BarcodeReader.productKeys = 'f0068NQAAAHB5UBrin/vPn1nBOErX0f2xk2n8135/3LLitF1pw/9LfIQpaf0fMe8CWM3+XJ1xFKoTWoCGuGsEHL0at47xUfQ=';
      Dynamsoft.DBR.BarcodeReader.productKeys = 'f0068MgAAAFaSwOV9PQmuapVc4Om2TlbiVw30EkM8X5YICM9zAh3eudUMqaG8zLsU1Rd32sFQP7DDk4UnzYKhpbk/k9ZfQ5E=';

      var $apnErxScanner = $('.js-apn-erx__scanner', $apnErx).first();
      if ($apnErxScanner.length > 0) {
        $('.js-apn-erx__scanner-init', $apnErx).off('click.Erx').on('click.Erx', function() {
          initScanner($apnErxScanner);
        });
      }

      var $apnErxUpload = $('.js-apn-erx__upload', $apnErx);
      if ($apnErxUpload.length > 0) {
        initReader($apnErxUpload);
      }
    }

    // Set Mobile Scanner Height
    if (isMobileDevice()) {
      var $scanner = $('.js-apn-erx__scanner');
      setTimeout(function() {
        // var scannerOffset = scanner.offset();
        // scanner.css('height', 'calc(100vh - ' + scannerOffset.top + 'px)');

        // setTimeout(function() {
        //   $scanner.addClass('-clear-cam');
        // }, 1500);
      }, 500);

      $('section', $apnErx).removeClass('col-md-8 col-md-4');
    }

    // Uncomment to always trigger the add2Basket Modal
    // addErxToCart([{"barcodeText": "{\"urls\":[\"Task/5e78f21cd6abc35edf4f1726c3d451ea2736d547a263f45726bc13a47e65d189/$accept?ac=d3e6092ae3af14b5225e2ddbe5a4f59b3939a907d6fdd5ce6a760ca71f45d8e5\"]}"}]);
  });
}());

